<div>
  <app-store-page-header (isLoadingStatus)=setLoadingValue($event)></app-store-page-header>
  <div class="d-block d-sm-none">
    <app-store-checkout-order-time-selector class="mb-1 store-checkout-time-selector"
      *ngIf="selectedStore && shouldDisplayDateSelection() && availableSlots" [userLang$]="userLang$"
      [deliveryTime]="deliveryTime" [showSlotSelection]="shouldDisplaySlotSelection()" [availableSlots]="availableSlots"
      (dateChanged)="onDateChanged($event)" (selectedSlotChanged)="onSelectedSlotChanged($event)"
      [timeShowEnabled]="!isTimeShowDisabled()" [timeFormat]="selectedStore?.settings?.TIME_FORMAT_SELECTION"
      [locale]="selectedStore?.locale" [timeZoneInput]="browserTimeZone">
    </app-store-checkout-order-time-selector>
  </div>
  <div id="top-anchor"></div>
  <div class="content-header" id="content-header" [ngClass]="{'pl-0': centerHeader()}"
    [style.top.px]="safeAreaHeight+searchBarTopHidden" #contentHeader>
    <div class="box-shadow-header">
      <div class="content-header-width w-100" [ngClass]="{'content-header-center': centerHeader()}">
        <app-store-sibling-selector id="sibling-selector" *ngIf="shouldDisplaySiblingSelection()"
          class="pl-3"></app-store-sibling-selector>
        <div class="d-flex flex-wrap align-items-center py-2 mx-2" id="search-bar">
          <app-store-checkout-order-time-selector class="mb-1 store-checkout-time-selector d-none d-sm-block"
            *ngIf="selectedStore && shouldDisplayDateSelection() && availableSlots" [userLang$]="userLang$"
            [deliveryTime]="deliveryTime" [showSlotSelection]="shouldDisplaySlotSelection()"
            [availableSlots]="availableSlots" (dateChanged)="onDateChanged($event)"
            (selectedSlotChanged)="onSelectedSlotChanged($event)" [timeShowEnabled]="!isTimeShowDisabled()"
            [timeFormat]="selectedStore?.settings?.TIME_FORMAT_SELECTION" [locale]="selectedStore?.locale" [timeZoneInput]="browserTimeZone">
          </app-store-checkout-order-time-selector>
          <div style="display: flex; flex: 1;" class="px-0 px-md-2 ml-0 catalog-search" [ngClass]="{
            'ml-md-2': !this.selectedStore?.settings.DELIVERY_IN_STORE_LOCATION_HIDE_FUTURE_WISH_DATE,
            'search-input-revser': isCategoryAction}">
            <input style="flex: 1;" [(ngModel)]="categorySearch" class="cat-search"
              (input)="onKeypressSearchCategory($event)" placeholder="{{'public.store.catalogSearchBar'| translate}}">
            <button class="cat-search-btn btn btn--line btn--md"
              [ngClass]="isCategoryAction ? 'search-action-revser' : ''">
              <i *ngIf="!categorySearch" class="fa fa-search" aria-hidden="true"></i>
              <i *ngIf="!!categorySearch" class="fa fa-times" (click)="clearSearchCategory()" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div style="flex: 1; text-align: center;">
          <div class="text-danger font-size-primary px-3 ml-1" *ngIf="showStoreClosedMessage()">
            {{ (checkoutService.isClosedForOrdering() ? 'public.store.currently.closed' : 'public.store.time.closed') |
            translate }}
          </div>
        </div>

        <div class="d-block w-100 ">
          <div class="nav-tabs-container px-2  px-md-3 position-relative widthContainer"
            [ngClass]="{'d-none': !topLevelCategories?.length || topCatalogView,
         'padding-left': !navMaxLeftScroll['top-level-nav-tab-wrapper'] ? '0' : 'initial',
         'padding':(!navMaxRightScroll['top-level-nav-tab-wrapper'] ||  !navMaxLeftScroll['top-level-nav-tab-wrapper'])}">
            <i class="fas fa-chevron-left d-flex text-secondary chevron-left position-absolute theme-color-secondary-text"
              [ngClass]="{'chevroncolor': !navMaxLeftScroll['top-level-nav-tab-wrapper']}"
              (click)="scrollNavToLeft('top-level-nav-tab-wrapper')"
              *ngIf="!navMaxLeftScroll['top-level-nav-tab-wrapper'] || !navMaxRightScroll['top-level-nav-tab-wrapper']"></i>
            <div class="w-100 py-3 nav-tabs-container" id="top-level-nav-tab-wrapper">
              <ul class="nav nav-tabs d-inline-flex ml-0 ml-md-2 " id="myTabs" role="tablist" #navTabTopContainer>
                <li *ngFor="let catItem of topLevelCategories; let first = first;" [ngClass]="{firstItem: first}"
                  role="presentation" class="catalog_category_li mx-3 position-relative text-unselectable"
                  [class.active_top]="selectedTopCat === catItem.categoryId" id="tab{{catItem.categoryId}}">
                  <a (click)="onSelectTopLevelCategory(catItem.categoryId)" aria-controls="one" role="tab"
                    data-toggle="tab" class="font-size-primary" [ngClass]="{ 'font-weight-bold': (selectedTopCat === catItem.categoryId),
                                'theme-color-header': (selectedTopCat === catItem.categoryId)
                              }">
                    {{catItem.name}}
                  </a>
                </li>
                <li role="presentation" class="catalog_category_li mx-3 position-relative text-unselectable"
                  [class.active_top]="!selectedTopCat" id="other-top-category" *ngIf="hasOtherTopLevelCategories">
                  <a (click)="onSelectTopLevelCategory(null)" aria-controls="one" role="tab" data-toggle="tab"
                    class="font-size-primary" [ngClass]="{ 'font-weight-bold': (!selectedTopCat),
                                'theme-color-header': (!selectedTopCat)
                              }">
                    {{"public.store.others"|translate}}
                  </a>
                </li>
                <li role="presentation" class="catalog_category_li ml-3 position-relative text-unselectable"
                  *ngIf="navMaxLeftScroll['top-level-nav-tab-wrapper'] && navMaxRightScroll['top-level-nav-tab-wrapper']"
                  id="other-top-category">
                  <a (click)="onSelectTopCatalogView()" aria-controls="one" role="tab" data-toggle="tab"
                    class="font-size-primary topCategoryViewButton">
                    <i class="fas fa-bars"></i>
                  </a>
                </li>
                <li role="presentation" class="catalog_category_li_grid ml-3 position-sticky text-unselectable"
                  *ngIf="!navMaxLeftScroll['top-level-nav-tab-wrapper'] || !navMaxRightScroll['top-level-nav-tab-wrapper']"
                  id="other-top-category">
                  <a (click)="onSelectTopCatalogView()" aria-controls="one" role="tab" data-toggle="tab"
                    class="font-size-primary topCategoryViewButton">
                    <i class="fas fa-bars"></i>
                  </a>
                </li>
              </ul>
            </div>
            <i class="fas fa-chevron-right text-secondary d-flex chevron-right position-absolute theme-color-secondary-text"
              [ngClass]="{'chevroncolor': !navMaxRightScroll['top-level-nav-tab-wrapper']}"
              (click)="scrollNavToRight('top-level-nav-tab-wrapper')"
              *ngIf="!navMaxLeftScroll['top-level-nav-tab-wrapper'] || !navMaxRightScroll['top-level-nav-tab-wrapper']"></i>
          </div>

          <div class="nav-tabs-container px-2 px-md-3 position-relative widthContainer"
            *ngIf="!topCatalogView && catalogLayoutView ==='LIST'" [ngClass]="{'d-none': (menuCategories && menuCategories.length <= 0) || topCatalogView,
          'padding-left': !navMaxLeftScroll['nav-tab-wrapper'] ? '0' : 'initial',
        'padding':(!navMaxRightScroll['nav-tab-wrapper'] ||  !navMaxLeftScroll['nav-tab-wrapper'])}">
            <i class="fas fa-chevron-left d-flex text-secondary chevron-left position-absolute theme-color-secondary-text"
              [ngClass]="{'chevroncolor': !navMaxLeftScroll['nav-tab-wrapper']}"
              (click)="scrollNavToLeft('nav-tab-wrapper')"
              *ngIf="!navMaxRightScroll['nav-tab-wrapper'] ||  !navMaxLeftScroll['nav-tab-wrapper']"></i>
            <div class="w-100 py-3 pb-4 nav-tabs-container" id="nav-tab-wrapper">
              <ul class="nav nav-tabs d-inline-flex ml-0 ml-md-2 mr-3" id="myTabs" role="tablist" #navTabContainer>
                <li *ngFor="let catItem of menuCategories; let first = first;" [ngClass]="{firstItem: first}"
                  role="presentation" class="catalog_category_li mx-0 mx-md-2 position-relative text-unselectable"
                  [class.active]="selectedCat === catItem.categoryId" id="tab{{catItem.categoryId}}">
                  <a (click)="onSelectCategory(catItem.categoryId)" aria-controls="one" role="tab" data-toggle="tab"
                    class="font-size-primary py-2 px-2 px-md-3 rounded" [ngClass]="{ 'font-weight-bold': (selectedCat === catItem.categoryId),
                                        'theme-color-header': (selectedCat === catItem.categoryId),
                                        'theme-light': (selectedCat === catItem.categoryId)
                                      }">
                    {{catItem.name}}
                  </a>
                </li>
              </ul>
            </div>
            <i class="fas fa-chevron-right text-secondary d-flex chevron-right position-absolute theme-color-secondary-text"
              [ngClass]="{'chevroncolor': !navMaxRightScroll['nav-tab-wrapper']}"
              (click)="scrollNavToRight('nav-tab-wrapper')"
              *ngIf=" !navMaxLeftScroll['nav-tab-wrapper'] || !navMaxRightScroll['nav-tab-wrapper']"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-loading-panel class="loading-panel"
    *ngIf="(!menuCategories || (selectedStoreStatus$ | async) !== 'LOADED' || selectedCatalog === -1) || isLoading"
    [showLoading]="true"></app-loading-panel>
  <div class="store-page container"
    [ngClass]="{ 'invisible': (!menuCategories || (selectedStoreStatus$ | async) !== 'LOADED' || selectedCatalog === -1) || isLoading}"
    [ngStyle]="{'padding-bottom.px': cookieBarHeight}">


    <!-- CATALOG LAYOUT LIST -->
    <app-catalog-layout-list *ngIf="catalogLayoutView ==='LIST'" [ngClass]="{'d-none': topCatalogView}"
      [menuCategories]="menuCategories" [gutterBottom]="showPayOnlineButton || (cartItems?.length > 0)"
      [cartItems]="cartItems" [categorySearch]="categorySearch" [selectedCat]="selectedCat"
      [searchSelectedCatList]="searchSelectedCatList" [selectedStoreLocale]="selectedStoreLocale"
      [selectedStoreCurrency]="selectedStoreCurrency" [selectedStoreCurrencySymbol]="selectedStoreCurrencySymbol"
      [showPayOnlineButton]="showPayOnlineButton" [totalValue]="cartItemsTotalValue()"
      [contentHeaderHeight]="contentHeaderHeight" [selectedCatalog]="selectedCatalog" [expandCategory]="expandCategory"
      [isIOSApp]="isIOSApp" (productDetailsViewed)="viewProductDetails($event)"
      (categorySelected)="onSelectCategory($event.categoryId, $event.toggle)"
      (itemAddedToCart)="onOneClickAddToCart($event)" (viewOrderDetails)="viewOrderItemDetails($event)"
      (decreaseItemQty)="onDecreaseItemQty($event)" (increaseItemQty)="onIncreaseItemQty($event)"
      (viewOrder)="onViewOrder($event)" (onlinePayment)="payOnline()">
    </app-catalog-layout-list>

    <!-- CATALOG LAYOUT TILES -->
    <app-catalog-layout-tiles *ngIf="catalogLayoutView ==='TILES'" [ngClass]="{'d-none': topCatalogView}"
      [menuCategories]="menuCategories" [selectedCat]="selectedCat" [categorySearch]="categorySearch"
      [cartItems]="cartItems" [selectedStoreLocale]="selectedStoreLocale"
      [selectedStoreCurrency]="selectedStoreCurrency" [selectedStoreCurrencySymbol]="selectedStoreCurrencySymbol"
      [contentHeaderHeight]="contentHeaderHeight" [safeAreaHeight]="safeAreaHeight"
      [customerFooterHeight]="customerFooterHeight" [searchBarTopHidden]="searchBarTopHidden"
      [selectedCatalog]="selectedCatalog" [isIOSApp]="isIOSApp" [showPayOnlineButton]="showPayOnlineButton"
      [cartItemsTotalValue]="cartItemsTotalValue()" [totalQuantity]="getTotalQuantity()"
      [acceptTermVisible]="acceptTermVisible" [expandCategory]="expandCategory"
      (productDetailsViewed)="viewProductDetails($event)"
      (categorySelected)="onSelectCategory($event.categoryId, $event.toggle)"
      (itemAddedToCart)="onOneClickAddToCart($event)" (decreaseItemQty)="onDecreaseItemQty($event)"
      (viewOrder)="onViewOrder($event)" (payOnline)="payOnline()">
    </app-catalog-layout-tiles>

    <app-top-catalog-view *ngIf="topCatalogView" [topCategoryContainerMarginBottom]="topCategoryContainerMarginBottom"
      [gutterBottom]="showPayOnlineButton || (cartItems?.length > 0)" [topLevelCategories]="topLevelCategories"
      [hasOtherTopLevelCategories]="hasOtherTopLevelCategories" (categorySelected)="onSelectTopLevelCategory($event)"
      (itemAddedToCart)="onOneClickAddToCart($event)">
    </app-top-catalog-view>
  </div>

  <!-- VIEW ORDER BUTTON -->
  <app-view-order-button *ngIf="catalogLayoutView ==='LIST'" [customerFooterHeight]="customerFooterHeight"
    [selectedCatalog]="selectedCatalog" [showPayOnlineButton]="showPayOnlineButton"
    [cartItemsTotalValue]="cartItemsTotalValue()" [totalQuantity]="getTotalQuantity()"
    [selectedStoreLocale]="selectedStoreLocale" [selectedStoreCurrency]="selectedStoreCurrency"
    [selectedStoreCurrencySymbol]="selectedStoreCurrencySymbol" [acceptTermVisible]="acceptTermVisible"
    [cartItems]="cartItems" (viewOrder)="onViewOrder($event)" (payOnline)="payOnline()">
  </app-view-order-button>

</div>